import React from 'react'

import './Background.scss'

const Background = (props) => (
  <div className="Background">
    {props.children}
  </div>
)

export default Background



// WEBPACK FOOTER //
// ./src/components/Background.js